import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { PrivateKeyRecoveryOptionMethodEnum } from '#src/__generated__/globalTypes.ts';
import { walletRecovery } from '#src/contexts/currentUser/queries.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  ActivateWalletRecoveryEmailMutation,
  ActivateWalletRecoveryEmailMutationVariables,
} from './__generated__/useActivateWalletRecoveryEmail.graphql.ts';

const ACTIVATE_WALLET_RECOVERY_EMAIL = gql`
  mutation ActivateWalletRecoveryEmailMutation(
    $input: activateWalletRecoveryInput!
  ) {
    activateWalletRecovery(input: $input) {
      currentUser {
        slug
        ...CurrentUserProvider_walletRecovery
      }
      errors {
        path
        message
        code
      }
    }
  }
  ${walletRecovery}
` as TypedDocumentNode<
  ActivateWalletRecoveryEmailMutation,
  ActivateWalletRecoveryEmailMutationVariables
>;

export const useActivateWalletRecoveryEmail = () => {
  const [mutate, { loading }] = useMutation(ACTIVATE_WALLET_RECOVERY_EMAIL, {
    showErrorsInForm: true,
  });

  const activateWalletRecoveryEmail = useCallback(
    async ({
      verificationCode,
      destination,
    }: {
      verificationCode: string;
      destination: string;
    }) => {
      const input = {
        verificationCode,
        destination,
        method: PrivateKeyRecoveryOptionMethodEnum.EMAIL,
      };
      const result = await mutate({
        variables: {
          input,
        },
      });
      return result;
    },
    [mutate]
  );

  return {
    activateWalletRecoveryEmail,
    loading,
  };
};
